import MuiCircularProgress, { CircularProgressProps as MuiCircularProgressProps } from '@mui/material/CircularProgress';

export type CircularProgressProps = MuiCircularProgressProps;

export const CircularProgress = (props: CircularProgressProps) => {
  return <MuiCircularProgress {...props} />;
};
